import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Paper,
  Container,
  Grid,
  Typography,
  IconButton,
  Drawer,
  Stack,
  Autocomplete,
  TextField,
  Box,
  TableFooter,
  CircularProgress,
} from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
// import { userService } from "../userService";
import { AlertBar } from "../Alert/AlertBar";
import { getEncryptPayload } from "../Network_Utility";
import {
  bankStatementImport,
  bankStatementImportV3,
  getAllBankAccounts,
} from "../config";
import moment from "moment";
import LoadingComponent from "../Loader";
import { styles } from "../Theme/Theme";
import {
  checkPathExist,
  checkPermissionExist,
  StyledTableCell,
  StyledTableRow,
} from "../utils";
import {
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import * as XLSX from "xlsx";
import Header from "../CommonComps/Header";
import { Button } from "@material-ui/core";
import { themecolor } from "../Navigation";
import { AXIS_BANK, CANARA_BANK, ICICI_BANK, INDIAN_BANK } from "./Constants";
import { loginService } from "../userService/loginUrl";
import { processAxisStatement, processICICIStatement } from "./ExcelProcess";

const BRIcon = require("../images/BR.png");

// const styles = (theme) => ({
//     paper: {
//         marginTop: theme.spacing(20),
//         marginBottom: theme.spacing(3),
//         padding: theme.spacing(2),

//         [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
//             marginTop: theme.spacing(6),
//             marginBottom: theme.spacing(6),
//             padding: theme.spacing(3),
//             marginLeft: theme.spacing(4),
//             marginRight: theme.spacing(4)
//         },
//         width: "100%"
//     }
// });

const Index = ({ classes }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const reduxState = useSelector((val) => val?.rootReducer);
  const storedSite = reduxState?.siteReducer?.site;
  const endPoints = reduxState?.permissionReducer?.data;
  const siteList = reduxState?.sitesReducer?.data;

  const [loading, setLoading] = useState(false);

  const [bank, setBank] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [totalWithdrawal, setTotalWithdrawal] = useState(0);
  const [totalDeposit, setTotalDeposit] = useState(0);

  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [accountNo, setAccountNo] = useState("");
  const [accountName, setAccountName] = useState("");
  const [totalEntery, setTotalEntery] = useState(0);
  const [statmentFile, setStatmentFile] = useState(null);

  const [isFetchBank, setIsFetchBank] = useState(false);

  // ===========Alerts===================//
  const [alerts, setAlerts] = useState({
    visible: false,
    alertMessage: "",
    alertType: "",
  });

  //==================Pagination====================//
  const [pageNo, setPageNo] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(15);
  const [totalPages, setTotalPages] = React.useState(1);
  const [transactionHistory, setTransactionHistory] = useState([]);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [showFilteredValues, setShowFilteredValues] = useState(null);

  // Function to close alert bar
  const closeAlertBar = () => setAlerts({ ...alerts, visible: false });

  // Function to show success alert bar
  const successAlert = (message) => {
    setAlerts({
      visible: true,
      alertMessage: message || "Data fetched successfully.",
      alertType: "success",
    });
    setLoading(false);
  };

  // Function to show error alert bar
  const errorAlert = (message) => {
    setAlerts({
      visible: true,
      alertMessage: message || "Something went wrong",
      alertType: "error",
    });
    setLoading(false);
  };

  const handleFileUpload = (event) => {
    try {
      setLoading(true);
      // debugger;
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const rawData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        if (!rawData || rawData.length === 0) {
          throw new Error("Invalid file format! The sheet is empty.");
        }
        // debugger;
        // Detect bank from file
        let detectedBank = selectedBank?.bankName;
        // let detectedBank = ICICI_BANK;

        // Proceed with processing based on bank type
        switch (detectedBank) {
          case ICICI_BANK:
            // processICICI(rawData, file);
            processICICIStatement({
              rawData,
              file,
              setAccountName,
              setAccountNo,
              setStatmentFile,
              setTransactions,
              setTotalWithdrawal,
              setTotalDeposit,
              setTotalEntery,
              setLoading,
              errorAlert,
            });
            break;
          case AXIS_BANK:
            // processAxis(rawData, file);
            processAxisStatement({
              rawData,
              file,
              setAccountName,
              setAccountNo,
              setStatmentFile,
              setTransactions,
              setTotalWithdrawal,
              setTotalDeposit,
              setTotalEntery,
              setLoading,
              errorAlert,
            });
            break;
          // case CANARA_BANK:
          //   processICICI(rawData, file);
          //   break;
          // case INDIAN_BANK:
          //   processICICI(rawData, file);
          //   break;
          default:
            errorAlert("Unsupported bank format.");
            setLoading(false);
        }
      };
      reader.readAsArrayBuffer(file);
      event.target.value = "";
    } catch (error) {
      errorAlert("Unsupported bank format.");
    }
  };

  //Function to get custom fields
  const fetchBankAccounts = async () => {
    const permissionExist = checkPermissionExist(endPoints, getAllBankAccounts);
    if (!permissionExist) {
      errorAlert("Access Denied!!");
      return;
    }
    setIsFetchBank(true);

    let payload = {
      accountId: 1432,
      // "statusId": 1, (1 - Matched, 2 - Partially Matched, 3 - Missing In Book, 4 - Missing In Bank)
      pageNo: 0,
      pageSize: 10,
    };
    const encryptedPayload = getEncryptPayload(payload, true);
    const siteId = localStorage.getItem("siteId");
    const url = `${getAllBankAccounts}?siteId=${+siteId}`;
    try {
      const response = await loginService.get(url);
      console.log(response);
      if (response && response.data && response.data.status === 200) {
        setBankList(response?.data?.data);
      }
    } catch (error) {
      errorAlert(error?.message);
      setIsFetchBank(false);
    } finally {
      setIsFetchBank(false);
    }
  };

  const handleReconciliation = async () => {
    const permissionExist = checkPermissionExist(
      endPoints,
      bankStatementImport
    );
    if (!permissionExist) {
      errorAlert("Access Denied!!");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("accountId", selectedBank.id);
    formData.append("file", statmentFile);
    formData.append("bankId", selectedBank.bankId);
    // const encryptedPayload = getEncryptPayload(payload, true);
    try {
      const response = await loginService.postData(
        bankStatementImportV3,
        formData
      );
      console.log(response);
      if (response && response.data && response.data.status === 200) {
        setLoading(false);
        navigate("/reconciled-statement", { state: { selectedBank } });
      } else {
        setLoading(false);
        errorAlert(response.data.message);
      }
    } catch (error) {
      setLoading(false);
      errorAlert(error?.message);
    }
  };

  useEffect(() => {
    fetchBankAccounts();
  }, []);

  return (
    <>
      <Paper
        className={classes.paper}
        elevation={0}
        style={{ width: "100%", overflow: "auto" }}
      >
        <Container style={{ maxWidth: "100%" }}>
          <Grid
            container
            style={{ margin: "0 0 10px 0", alignItems: "center" }}
          >
            <Header
              gridSize="3"
              source={BRIcon}
              headerText={"Bank Reconciliation"}
            />
          </Grid>
          <Grid container spacing={1} mt={1} justifyContent={"center"}>
            <Grid item md={3}>
              <Autocomplete
                options={bankList}
                loading={isFetchBank} // <-- loading state
                size="small"
                fullWidth
                value={selectedBank || null}
                getOptionLabel={(option) => option?.name || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.name === value?.name
                } // updated for MUI v5+
                onChange={(event, newValue) => setSelectedBank(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Bank"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {isFetchBank ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item md={2}>
              <Button
                disabled={!selectedBank}
                variant="contained"
                component="label"
                style={{ background: `${themecolor}`, color: "#fff" }}
              >
                Upload Statement
                <input
                  type="file"
                  hidden
                  accept=".xlsx,.xls"
                  onChange={handleFileUpload}
                />
              </Button>
            </Grid>
          </Grid>
          {/* <Select
            value={bank}
            onChange={(e) => setBank(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Select Bank</MenuItem>
            <MenuItem value="HDFC">HDFC</MenuItem>
            <MenuItem value="ICICI">ICICI</MenuItem>
          </Select> */}

          {transactions.length > 0 && (
            <Grid container spacing={1} mt={2}>
              <Grid item md={8}>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
                >
                  <Typography>
                    <strong>Ledger Name: </strong> {accountName}
                  </Typography>
                  <Typography>
                    <strong>Account No: </strong> {accountNo}
                  </Typography>
                  <Typography>
                    <strong>Total entries: </strong> {totalEntery}
                  </Typography>
                </Box>
              </Grid>
              <Grid item md={4}>
                <Typography>
                  <strong>Last date of entry in statement: </strong>{" "}
                  {transactions.length > 0
                    ? transactions[transactions?.length - 1].date || "NA"
                    : ""}
                </Typography>
              </Grid>
            </Grid>
          )}

          {transactions.length > 0 && (
            <TableContainer
              component={Paper}
              style={{
                marginTop: 20,
                height:
                  transactions &&
                  transactions.length > 0 &&
                  "calc(100vh - 410px)",
              }}
            >
              <Table aria-label="table" stickyHeader>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>S.No</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Particulars</StyledTableCell>
                    <StyledTableCell>Inst No</StyledTableCell>
                    <StyledTableCell>Withdrawal</StyledTableCell>
                    <StyledTableCell>Deposit</StyledTableCell>
                    <StyledTableCell>Balance</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {transactions.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{row.sNo}</StyledTableCell>
                      <StyledTableCell>{row.date}</StyledTableCell>
                      <StyledTableCell>{row.particulars}</StyledTableCell>
                      <StyledTableCell>{row.instNo}</StyledTableCell>
                      <StyledTableCell>
                        {row.withdrawal.toFixed(2)}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.deposit.toFixed(2)}
                      </StyledTableCell>
                      <StyledTableCell>{row.balance}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <StyledTableRow
                    style={{
                      position: "sticky",
                      bottom: 0,
                      background: "#fff",
                      zIndex: 2,
                    }}
                  >
                    <StyledTableCell colSpan={4} align="right">
                      <strong>Total</strong>
                    </StyledTableCell>
                    <StyledTableCell>
                      <strong>{totalWithdrawal.toFixed(2)}</strong>
                    </StyledTableCell>
                    <StyledTableCell>
                      <strong>{totalDeposit.toFixed(2)}</strong>
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </StyledTableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}

          {transactions.length > 0 && (
            <Grid container mt={2}>
              <Grid item md={12}>
                <Box sx={{ textAlign: "center" }}>
                  <Button
                    variant="contained"
                    style={{ background: `${themecolor}`, color: "#fff" }}
                    onClick={handleReconciliation}
                  >
                    Reconcile
                  </Button>
                </Box>
              </Grid>
            </Grid>
          )}
        </Container>
      </Paper>

      {/* ==============Alerts=============== */}
      <AlertBar
        visible={alerts?.visible}
        closeAlertBar={closeAlertBar}
        alertMessage={alerts?.alertMessage}
        alertType={alerts?.alertType}
      />

      {/* ==========Loader Container======= */}
      {loading && <LoadingComponent />}
    </>
  );
};

export default withStyles(styles)(Index);
